<gap-side-navigation
	[ngClass]="{ main_navigation: isMainNav, 'gap-side-navigation--rounded mobile_navigation': !isMainNav }"
	gap-color="primary"
>
	<gap-side-navigation-button
		*ngIf="isMobileOpen"
		slot="close"
		aria-label="Close side menu"
		(click)="closeMobileNav()"
	>
		<gap-iconography aria-hidden="true" gap-icon="close-outline" slot="prefix"></gap-iconography>
		{{ 'common.close' | locale }}
	</gap-side-navigation-button>
	<div *ngIf="isMobileOpen" slot="close" class="gap-side-navigation__divider"></div>
	<gap-side-navigation-section class="gap-side-navigation__app-name">
		{{ 'nav.appname' | locale }}
	</gap-side-navigation-section>
	<div *ngIf="supportedLanguages?.length" class="gap-side-navigation__divider"></div>
	<ahp-swap-language
		*ngIf="supportedLanguages?.length" 
		[isSideNav]="true"
		class="side-navigation__swap-language"
	></ahp-swap-language>
	<div class="gap-side-navigation__divider"></div>
	<gap-side-navigation-section>
		<div *ngFor="let navItem of navItems" [ngClass]="{ hidden: !navItem.displayIf }">
			<div *ngIf="navItem.type === 'dropdown'">
				<gap-side-navigation-dropdown [gapOpen]="navItem.gapOpen">
					<gap-side-navigation-button
						#gapDropdown
						slot="button"
						(click)="toggleNavDropdown(navItem)"
						(keydown.enter)="toggleNavDropdown(navItem)"
						(keydown.space)="toggleNavDropdown(navItem)"
						[attr.data-cy]="'side-navigation__button--' + navItem.id"
					>
						{{ navItem.dropDownName }}
					</gap-side-navigation-button>
					<gap-iconography
						[attr.gap-icon]="navItem.gapOpen ? 'expand-less-outline' : 'expand-more-outline'"
						slot="buttonicon"
						(click)="toggleNavDropdown(navItem)"
					></gap-iconography>
					<gap-side-navigation-button
						slot="dropdown"
						*ngFor="let dropdownButton of navItem.buttons"
						[ngClass]="{ hidden: !dropdownButton.displayIf }"
						(click)="clickAction(dropdownButton.clickAction, dropdownButton.clickActionPayload)"
						(keydown.enter)="clickAction(dropdownButton.clickAction, dropdownButton.clickActionPayload)"
						(keydown.space)="clickAction(dropdownButton.clickAction, dropdownButton.clickActionPayload)"
						[attr.gap-selected]="setIsSelected(dropdownButton.routeEnd)"
						[attr.aria-current]="setIsSelected(dropdownButton.routeEnd) ? 'page' : 'false'"
						ahpAnalyticsClick="{{ dropdownButton.analyticsClick }}"
						[attr.data-cy]="'side-navigation__button--' + dropdownButton.id"
						[attr.aria-hidden]="navItem.gapOpen ? 'true' : 'false'"
						[tabindex]="navItem.gapOpen ? -1 : 0"
					>
						{{ dropdownButton.label }}
					</gap-side-navigation-button>
				</gap-side-navigation-dropdown>
			</div>
			<gap-side-navigation-button
				*ngIf="navItem.type !== 'dropdown'"
				(click)="clickAction(navItem.clickAction, navItem.clickActionPayload)"
				(keydown.enter)="clickAction(navItem.clickAction, navItem.clickActionPayload)"
				(keydown.space)="clickAction(navItem.clickAction, navItem.clickActionPayload)"
				[attr.gap-selected]="setIsSelected(navItem.routeEnd)"
				[attr.aria-current]="setIsSelected(navItem.routeEnd) ? 'page' : 'false'"
				ahpAnalyticsClick="{{ navItem.analyticsClick }}"
				[attr.data-cy]="'side-navigation__button--' + navItem.id"
				>{{ navItem.label }}
			</gap-side-navigation-button>
		</div>
	</gap-side-navigation-section>
	<div class="footer-wrapper">
		<div class="footer-spacer"></div>
		<div class="footer-content">
			<img
				class="footer__logo"
				data-cy="side-navigation__image--accessoLogo"
				ngSrc="/assets/logo/accesso-passport-logo--white.svg"
				width="435"
				height="211"
				[alt]="accessoLogoAltText"
			/>
			<div class="footer__text gap-font--caption">
				<div class="footer__copyright">© {{ buildTimestamp }} accesso Technology Group, PLC.</div>
				<div class="footer__version">{{ 'common.version' | locale }}: {{ buildVersion }}</div>
				<div class="footer__session-id">{{ 'common.sessionId' | locale }}: {{ sessionId }}</div>
			</div>
		</div>
	</div>
</gap-side-navigation>
